import { FormGroup } from "@angular/forms";

export interface Context {
  dataContext: ContextMenu;
  contextMenuItems: ContextMenuItems[];
}

export interface ContextMenuItems {
  isDivider: boolean;
  event?: string;
  hidden?: boolean;
  disabled?: boolean;
  icon?: string;
  text?: string;
  hasBadge?: boolean;
  badgeValue?: number | string;
  badgeDisabled?: boolean;
  selected?: boolean;
  isWarning?: boolean;
}

export interface ContextMenu {
  function?: string;
  clickEvents?: ButtonClickEvents;
  index?: number;
  row?: any;
  formGroup?: FormGroup;
  selection?: number;
  disabled?: boolean;
  hidden?: boolean;
  data?: any;
  additionalData?: any;
  forceContextMenu?: boolean;
  defaultAction?: string;
  isInput?: boolean; // Determines if context menu is being opened on an input
  inputGetCoordinates?: Function; // Custom method to getting coordinates
}

/**
 *
 */
export enum ButtonClickEvents {
  LEFT_BUTTON = 1,
  RIGHT_BUTTON = 2,
  BOTH = 3
}
